import type { ComponentProps } from 'react';
import type React from 'react';

import { Button } from '@change/ds-core-ui';

type Props = Omit<ComponentProps<typeof Button>, 'onClick'> & {
	onClick?: () => void;
};

export const CustomButton: React.FC<Props> = ({ children, inverted, onClick, ...rest }) => {
	return (
		// eslint-disable-next-line @change-corgi/require-data-qa-attribute
		<Button variant="primary" className="w-full" onClick={() => onClick?.()} {...rest}>
			{children}
		</Button>
	);
};
